'use memo';

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { AlertCard } from '@/components/AlertCard';
import { VStack } from '@/components/Layout';
import { ViewportLoader } from '@/components/Loading';
import { toast } from '@/components/ui/use-toast';
import { authPoliciesKeyPrefix, toPolicyFormValue, useAuthenticationPolicy, useUpdateAuthenticationPolicy } from '@/features/authentication-policy';
import { handleApiError } from '@/lib/api/error';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { PolicyStepperScreen } from '../-components/PolicyStepperScreen';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/policies/$id/')({
  component: EditAuthPolicyPage
});
function EditAuthPolicyPage() {
  const {
    id
  } = Route.useParams();
  const {
    i18n,
    t
  } = useTranslation(defaultNS, {
    keyPrefix: authPoliciesKeyPrefix
  });
  const navigate = useNavigate();
  const {
    data,
    isPending,
    isError
  } = useAuthenticationPolicy(id);
  const updateMutation = useUpdateAuthenticationPolicy();
  const [errorMessage, setErrorMessage] = useState('');
  const baseLink = `/settings/authentication/policies/${id}`;
  const backToList = () => navigate({
    to: '/settings/authentication/policies'
  });
  if (isPending) return <ViewportLoader />;
  if (isError || data == null) {
    return <VStack className="w-full gap-4 p-10">
        <AlertCard variant="mutedError" description={t($ => $.list.loadError)} />
      </VStack>;
  }
  return <PolicyStepperScreen key={data.id} baseLink={baseLink} isEdit initialValue={() => toPolicyFormValue(data)} isDefault={data.isDefault} policyId={data.id} isSubmitting={updateMutation.isPending} errorMessage={errorMessage} editTarget={{
    name: data.name,
    priority: data.priority
  }} onSubmit={draft => {
    setErrorMessage('');
    updateMutation.mutate({
      ...draft,
      id
    }, {
      onSuccess: () => {
        toast({
          description: t($ => $.toast.updated)
        });
        void backToList();
      },
      onError: error => {
        setErrorMessage(handleApiError(error, {
          language: i18n.language
        }).message);
      }
    });
  }} />;
}